import React, { useState, useEffect } from 'react'
import { Skeleton } from 'antd';
import { ReactComponent as PrequestLogo } from './../../media/Prequest_logo_color.svg'

export default function LoginHeader() {
    const isLoading = useLoadingFinished()

    if (isLoading) {
        return (
            <>
                <Skeleton title={false} paragraph={{ rows: 1 }} />
            </>
        )
    }
    return (
        <>
            <PrequestLogo className='login-header-logo' />
        </>
    )
}

function useLoadingFinished() {
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        setIsLoading(false);
    }, []);

    return isLoading
}